import $ from 'jquery';

let photoGalleryListEl = $('.photo-gallery-list');

$(function () {
    if (photoGalleryListEl.length > 0) {
        photoGalleryListEl.each(function () {
            photoGalleryTable($(this));
        });
    }
});

const photoGalleryTable = (tableEl) => {

    const filter = {
        page: 1,
        limit: tableEl.data('limit'),
        selectedGallery: tableEl.data('galleries'),
        lang: tableEl.data('lang'),
        showFilter: tableEl.data('filter'),
        search: '',
        year: -1,
        month: -1,
        category: -1
    }

    bindPhotoGallery(tableEl, filter);
    bindPhotoGalleryFilter(tableEl, filter);
}

const reRenderPhotoGallery = async (element, filter) => {
    const data = await getPhotoGallery(filter);
    element.find('.photo-gallery-list__content').html(data.html);
}

const bindPhotoGallery = (element, filter) => {
    element.on('click', '.pagination__item', function () {
        filter.page = $(this).data('page');
        reRenderPhotoGallery(element, filter);
    });
}

const bindPhotoGalleryFilter = (element, filter) => {
    element.on('keyup', "input[name='photoGallery-search']", function () {
        delay(function () {
            filter.page = 1;
            filter.search = element.find("input[name='photoGallery-search']").val();
            reRenderPhotoGallery(element, filter);
        }, 400);
    });

    element.on('change', "select[name='photoGallery-years']", function () {
        filter.page = 1;
        filter.year = $(this).val();
        reRenderPhotoGallery(element, filter);
    });

    element.on('change', "select[name='photoGallery-months']", function () {
        filter.page = 1;
        filter.month = $(this).val();
        reRenderPhotoGallery(element, filter);
    });

    element.on('change', "select[name='photoGallery-categories']", function () {
        filter.page = 1;
        filter.category = $(this).val();
        reRenderPhotoGallery(element, filter);
    });

    element.on('click', "button[name='remove-filter']", function () {
        filter.search = '';
        filter.year = -1;
        filter.month = -1;
        filter.category = -1;

        element.find("select[name='photoGallery-years']").val('-1');
        element.find("select[name='photoGallery-months']").val('-1');
        element.find("input[name='photoGallery-search']").val('');
        element.find("select[name='photoGallery-categories']").val('-1');

        reRenderPhotoGallery(element, filter);
    });
}

const getPhotoGallery = async (filter) => {
    try {
        const response = await fetch(`/wp-json/kremnica/v1/photo-gallery-list/html`, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            }),
            body: JSON.stringify(filter),
        });
        const result = await response.json();
        return result;
    } catch (e) {
        return null;
    }
}

const delay = (function () {
    let timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();